import React from 'react';
import { Grid, Container, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTheme } from '../../../ThemeContext';

const MainLayout = ({ leftContent, rightContent }) => {
  const { themeMode, currentTheme } = useTheme();

  const StyledContainer = styled(Container)(({ theme }) => ({
    height: '90vh',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: 0,
    paddingRight: 0,
    maxWidth: '100%',
    marginLeft: '0px',
  }));
  
  const StyledGridItem = styled(Grid)(({ theme }) => ({
    height: '100%',
    '& > *': {
      height: '100%'
    }
  }));

  return (
    <StyledContainer maxWidth="xl">
      <Grid 
        container 
        spacing={3}
        sx={{ height: '100%' }}
      >
        {/* 
          Responsive grid system:
          - xs={12} (100% width on mobile)
          - sm={5} (41.67% width on small screens)
          - md={4} (33.33% width on medium screens)
          - lg={4} (33.33% width on large screens)
        */}
        <StyledGridItem 
          item 
          xs={12} 
          sm={5}
          md={4} 
          lg={4}
          sx={{
            borderRight: {
              xs: 'none', 
              sm: `1px solid ${themeMode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'}`
            },
            borderBottom: {
              xs: `1px solid ${themeMode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'}`, 
              sm: 'none'
            },
            pb: {xs: 2, sm: 0},
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start'
          }}
        >
          <Box sx={{ 
            width: '100%',
            maxWidth: '450px',
            pr: { sm: 2 }
          }}>
            {leftContent}
          </Box>
        </StyledGridItem>
        
        <StyledGridItem 
          item 
          xs={12} 
          sm={7} 
          md={8} 
          lg={8}
        >
          <Box sx={{ 
            height: '100%', 
            pl: { sm: 2 },
            pt: {xs: 2, sm: 0} 
          }}>
            {rightContent}
          </Box>
        </StyledGridItem>
      </Grid>
    </StyledContainer>
  );
};

export default MainLayout; 